<div class="card settings-page">
  @if (isLoading()) {
    <app-loader [loading]="isLoading()"/>
  } @else {
    <div class="card-body">
      <app-list-grid-client-side
        [rowData]="reminders"
        [colDefs]="colDefs"
        [rowSelection]="remindersRowSelection"
        [suppressRowClickSelection]="true"
        [suppressCellFocus]="true"
        (gridReady)="onGridReady($event)"
      />
    </div>
  }
</div>
